<template>
  <div class="heightPage"
       element-loading-text="数据加载中">
    <el-page-header @back="goBack"
                    content="企业认证"> </el-page-header>
    <el-divider></el-divider>
    <div class="myForm">
      <div class="form">
        <div class="title">企业信息</div>
        <el-form ref="companyform"
                 :model="form"
                 :rules="rules"
                 label-width="135px"
                 size="small"
                 v-enterToNext="true">
          <el-form-item label="营业执照"
                        prop="license">
            <el-upload :class="{ 'hide-upload': isHideUpload }"
                       action=""
                       accept=".jpg,.png"
                       :limit="1"
                       list-type="picture-card"
                       :file-list="form.license"
                       :before-remove="removeLicense"
                       :http-request="uploadLicense">
              <i class="el-icon-plus"></i>
              <div slot="tip"
                   class="el-upload__tip">
                只能上传jpg/png文件，且不超过10M
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="企业名称"
                        prop="companyName">
            <el-input v-model="form.companyName"
                      maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="企业简称"
                        prop="companyShortName">
            <el-input v-model="form.companyShortName"
                      maxlength="7"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码"
                        prop="creditCode">
            <el-input v-model="form.creditCode"> </el-input>
          </el-form-item>
          <el-form-item label="企业所在地"
                        prop="address">
            <el-input v-model="form.address"
                      maxlength="49"> </el-input>
          </el-form-item>
          <el-form-item label="企业联系人"
                        prop="contactName">
            <el-input v-model="form.contactName"
                      maxlength="11"> </el-input>
          </el-form-item>
          <el-form-item label="手机号码"
                        prop="contactPhone">
            <el-input v-model="form.contactPhone"
                      maxlength="11"> </el-input>
          </el-form-item>
          <!-- <el-form-item label="是否园区" prop="isEnterPark">
            <el-checkbox
              v-model="form.isEnterPark"
              @change="$set(form, 'parkId', '')"
              >是</el-checkbox
            >
          </el-form-item>
          <el-form-item label="园区名称" prop="parkId" v-if="form.isEnterPark">
            <el-select
              v-model="form.parkId"
              ref="select"
              placeholder="请选择园区"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <div style="text-align: center; margin-top: 40px">
            <el-button size="medium"
                       type="primary"
                       @click="save('companyform')">提交认证</el-button>
          </div>
        </el-form>
      </div>
      <el-dialog title="提示"
                 :visible.sync="tipVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="700px">
        <div class="tip"
             style="font-size: 16px">
          <div style="margin-bottom: 15px">
            保留当前个人账户(非园区)：当前账户依然为个人账户并且保留数据，系统将自动创建一个数据重置的账户为企业账户。
          </div>
          <div v-if="!$store.state.isPersonage">
            当前个人账户认证为企业账户：把当前账户认证为企业账户并且保留数据
            ，系统将自动创建一个数据重置的账户为个人账户。
          </div>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="
              () => {
                tipVisible = false;
              }
            ">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     :disabled="CompanyDetail.isEnterPark"
                     @click="AuthenticationSelect(true)">保留当前个人账户(非园区)</el-button>
          <el-button size="small "
                     type="primary"
                     @click="AuthenticationSelect(false)"
                     v-if="!$store.state.isPersonage"
                     :loading="submitLoading">当前个人账户认证为企业账户</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>


<script>
import IDCard from "china-id-card";
export default {
  data () {
    let validatePhone = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    let validateIdcard = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (IDCard(value).isVerified != true) {
        callback(new Error("身份证号码不正确"));
      } else {
        callback();
      }
    };
    let validatecreditCode = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (
        !/^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/.test(
          value
        )
      ) {
        callback(new Error("统一社会信用代码不正确"));
      } else {
        callback();
      }
    };
    return {
      submitLoading: false,
      form: { license: [], isEnterPark: false },
      rules: {
        contactName: [
          { required: true, message: "请输入企业联系人", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        legalRepresentative: [
          { required: true, message: "请输入法人姓名", trigger: "blur" },
        ],
        legalRepresentativeIdentityCard: [
          { required: true, message: "请输入法人身份证号", trigger: "blur" },
          { validator: validateIdcard, trigger: "blur" },
        ],
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        parkId: [{ required: true, message: "请选择园区", trigger: "blur" }],
        companyShortName: [
          { required: true, message: "请输入企业简称", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入企业所在地", trigger: "blur" },
        ],
        creditCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
          { validator: validatecreditCode, trigger: "blur" },
        ],
        license: [
          { required: true, message: "请上传营业执照", trigger: "blur" },
        ],
      },
      tipVisible: false,
      isHideUpload: false,
      options: [],
      CompanyDetail: {},
    };
  },
  mounted () {
    console.log(this.$parent.$children[0]);
    this.CompanyDetail = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    );

    // this.getParkManage();
  },
  methods: {
    getParkManage () {
      this.$api.parkManage.ParkList().then((res) => {
        if (res.code === 0) {
          this.options = res.data;
        }
      });
    },
    goBack () {
      this.$router.go(-1);
    },
    removeLicense () {
      this.form.license.splice(0, 1);
      this.isHideUpload = false;
      console.log(this.form);
    },
    uploadLicense (fileObj) {
      this.submitLoading = true;

      this.$api.upload
        .uploadSingleImage(fileObj.file)
        .then((res) => {
          if (res.code === 0 && res.data[0]) {
            this.isHideUpload = true;
            this.OcrBusinessLicense(res.data[0]);
            this.form.license.push({ name: "", url: res.data[0] });

            this.$refs.companyform.validateField(["license"]);
          }
        })
        .catch((error) => {
          this.submitLoading = false;

          if (error.response?.status == 400) {
            this.$message.warning("请上传jpg、png格式的图片");
            this.form.license = [];
          }
        });
    },
    OcrBusinessLicense (url) {
      let sendData = {
        httpUrl: "https://" + url,
      };
      this.$api.thirdyParty.OcrBusinessLicense(sendData).then((res) => {
        this.submitLoading = false;
        if (res.code === 0) {
          this.$set(this.form, "companyName", res.data.companyName);
          this.$set(this.form, "creditCode", res.data.socialCreditCode);
          this.$set(this.form, "address", res.data.address);
          this.$set(this.form, "contactName", res.data.legalPerson);
        } else if (res.code == 2) {
          this.removeLicense();
          this.$message.error("请上传正确的营业执照");
        }
      });
    },
    getCompanyDetail () {
      this.$api.user.CompanyDetail().then((res) => {
        if (res.code === 0) {
          this.form = res.data;
          window.localStorage.setItem(
            "CompanyDetail",
            JSON.stringify(res.data)
          );
          this.$store.commit("change", res.data);
        }
      });
    },
    save (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.$message.warning("填写信息有误，请检查表单");

          return;
        }
        this.tipVisible = true;
      });
    },
    logout () {
      var lirm = localStorage.getItem("lirm");
      var lap = localStorage.getItem("lap");
      window.localStorage.clear();
      window.sessionStorage.clear();

      //如果记住密码，则留存
      if (lirm == 1) {
        localStorage.setItem("lap", lap);
      }
      this.$router.replace("/loginform");
      store.state.tabList = [];
    },
    AuthenticationSelect (flag) {
      let sendData = {
        // id: JSON.parse(localStorage.getItem("CompanyDetail")).id,
        retainIndividualAccount: flag,
        companyName: this.form.companyName,
        legalRepresentative: this.form.legalRepresentative,
        legalRepresentativeIdentityCard:
          this.form.legalRepresentativeIdentityCard,
        businessLicencePath: this.form.license ? this.form.license[0].url : "",
        contactName: this.form.contactName,
        contactPhone: this.form.contactPhone,
        creditCode: this.form.creditCode,
        companyShortName: this.form.companyShortName,
        address: this.form.address,
        isEnterPark: this.CompanyDetail.isEnterPark
          ? this.CompanyDetail.isEnterPark
          : false,
        parkId: this.CompanyDetail.parkId ? this.CompanyDetail.parkId : "",
        parkName: this.CompanyDetail.parkName
          ? this.CompanyDetail.parkName
          : "",
      };
      this.submitLoading = true;
      this.$api.user.IndividualAccountAuthentication(sendData).then((res) => {
        this.submitLoading = false;
        if (res.error === false) {
          this.tipVisible = false;
          this.$message.success("申请成功，将再两秒后退出登录！");
          setTimeout(() => {
            this.logout();
          }, 2000);
          // this.$router.replace("/home");
          // this.$parent.$children[0].removeTab("/certifiSelection");
          // this.$store.commit("change", { authenticationState: 1 });
          // this.CompanyDetail();
        } else if (res.code == 1) {
          this.$message.success(res.msg);
          this.getCompanyDetail();
          this.$parent.$children[0].removeTab("/certifiSelection");
        }
      });
    },
  },
};
</script>
<style lang="less">
.hide-upload {
  .el-upload--picture-card {
    display: none;
  }
}
</style>
<style lang="less" scoped>
.heightPage {
  overflow: auto;
  .myForm {
    padding: 15px;
    .title {
      color: #303133;
      padding-left: 8px;
      border-left: 3px solid #409eff;
      font-size: 16px;
      text-align: left;
      margin-bottom: 20px;
    }
    .form {
      width: 30%;
      margin: 0 auto;
      margin-top: 5px;
    }
  }
}
</style>